import { post } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';

const API_NAME = 'AdminQueries';

async function getAuthHeader() {
  const { accessToken } = (await fetchAuthSession()).tokens ?? {};
  if (!accessToken) {
    throw new Error('accessToken unavailable');
  }
  return {
    authorization: `Bearer ${accessToken}`
  };
}

export async function deleteUser(username: string) {
  const authHeader = await getAuthHeader();
  const restOperation = post({
    apiName: API_NAME,
    path: '/organization/deleteUser',
    options: { body: { username }, headers: authHeader }
  });
  const response = await restOperation.response;
  if (response.statusCode !== 200) {
    throw new Error('User could not be deleted');
  }
}

/* Call for adding new Admin users */
export const createUserAPI = async (
  orgId: string,
  firstName: string,
  surName: string,
  email: string,
  isAdmin: boolean
) => {
  try {
    const { inviteUser } = await import('@/client/organization');

    const result = await inviteUser({
      email,
      firstName,
      lastName: surName,
      organizationId: orgId,
      isAdmin
    });

    return result;
  } catch (e: any) {
    console.log(`Error in Admin Invite Flow `, e?.message || e);
    throw new Error(e?.message || `Failed to invite ${isAdmin ? 'admin' : 'host'}`);
  }
};

// export async function updateUserHostAdminStatus(username: string, newStatus: string) {
// const authHeader = await getAuthHeader();
// if (newStatus === RoleType.host) {
//   const removeAdminStatus = post({
//     apiName: API_NAME,
//     path: '/removeUserFromGroup',
//     options: { body: { username: username, groupname: RoleType.admin }, headers: authHeader }
//   });
//   const removeAdmin = await removeAdminStatus.response;
//   if (removeAdmin.statusCode !== 200) {
//     throw new Error('Admin status could not be removed');
//   }
// }
// if (newStatus === RoleType.admin) {
//   const addAdminStatus = post({
//     apiName: API_NAME,
//     path: '/addUserToGroup',
//     options: { body: { username: username, groupname: RoleType.admin }, headers: authHeader }
//   });
//   const addAdmin = await addAdminStatus.response;
//   if (addAdmin.statusCode !== 200) {
//     throw new Error('Error adding admin status');
//   }
// }
// }
